import React from "react";
import PropTypes from "prop-types";
import {
  Popper,
  Paper,
  MenuList,
  MenuItem,
  Grow,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  popper: {
    zIndex: 1300,
  },
  paper: {
    minWidth: 160,
    maxHeight: 400,
    overflow: "auto",
    boxShadow: "0px 5px 15px 0px rgba(0, 0, 0, 0.3)",
  },
  menuItem: {
    fontSize: "0.875rem",
    padding: theme.spacing(1, 2),
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  menuItemActive: {
    backgroundColor: (props) => `${props.clientColor}15`,
    color: (props) => props.clientColor,
    fontWeight: 500,
    "&:hover": {
      backgroundColor: (props) => `${props.clientColor}25`,
    },
  },
}));

const FilterDimensionMenu = React.forwardRef(function FilterDimensionMenu(
  {
    open,
    anchorEl,
    dimensions,
    onDimensionSelect,
    activeDimensions,
    selectedFilters,
    clientColor,
  },
  ref,
) {
  const classes = useStyles({ clientColor });

  const handleDimensionClick = (dimension) => {
    // Now just pass the dimension, no need for menu item element
    onDimensionSelect(dimension);
  };

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      transition
      className={classes.popper}
      ref={ref}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps}>
          <Paper className={classes.paper} elevation={2}>
            <MenuList>
              {dimensions.map((dimension) => {
                const isActive = activeDimensions.includes(dimension.key);
                const filterCount = selectedFilters[dimension.key]?.length || 0;
                return (
                  <MenuItem
                    key={dimension.key}
                    onClick={(event) => {
                      event.stopPropagation();
                      handleDimensionClick(dimension, event);
                    }}
                    className={
                      isActive ? classes.menuItemActive : classes.menuItem
                    }
                  >
                    {dimension.label}
                    {isActive && ` (${filterCount})`}
                  </MenuItem>
                );
              })}
            </MenuList>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
});

FilterDimensionMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  dimensions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onDimensionSelect: PropTypes.func.isRequired,
  activeDimensions: PropTypes.array,
  selectedFilters: PropTypes.object,
  clientColor: PropTypes.string.isRequired,
};

FilterDimensionMenu.defaultProps = {
  activeDimensions: [],
  selectedFilters: {},
};

export default FilterDimensionMenu;
